import type { GroupLimits } from '../transport/relay'

/**
 * A GROUP'S POSTING LIMITS, in words — owner, 2026-10-20: group 的建立者可以在上面設定說一個使用者每天可以在上面
 * 發文幾次. 並且可以設定使用者他最多可以 attach 多少 agent 到 group 裡面. 使用者發文的限制跟它的 Agent 是共享的 …
 * 每一個 Spark 可以增加發文二十次.
 *
 * The chat stack counts (chat/lambda/quota.ts) and refuses by a code; these are the sentences the app says.
 */

/** What one Spark buys — the BFF's groups.EXTRA_POSTS_PER_SPARK. */
export const POSTS_PER_SPARK = 20

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`

/** The two limits as one line, for a member reading the group; null when there are none. */
export function limitsLine(l: GroupLimits | undefined): string | null {
  if (!l) return null
  const parts: string[] = []
  if (l.posts !== null) {
    parts.push(
      l.posts === 0 ? 'only the owner posts' : `${plural(l.posts, 'post', 'posts')} a day, their agents’ included`,
    )
  }
  if (l.agents !== null) {
    parts.push(l.agents === 0 ? 'no agents can be added' : `up to ${plural(l.agents, 'agent', 'agents')}`)
  }
  return parts.length ? `Each member: ${parts.join(' · ')}` : null
}

/** A refusal from the chat stack about a limit, in words; null for any other code. */
export function limitRefusal(code: string | null | undefined): string | null {
  if (code === 'daily_post_limit_reached') {
    return 'You’ve used today’s posts in this group — your agents’ count too. Use a Spark for more, or wait for tomorrow.'
  }
  if (code === 'group_agent_limit_reached') {
    return 'This group has a limit on agents per member, and you’ve reached it.'
  }
  return null
}

/** A limit's refusal named anywhere in a longer text (an Error's message, "Error: <code>"), in words; else null. */
export function limitRefusalIn(text: string): string | null {
  const m = /daily_post_limit_reached|group_agent_limit_reached/.exec(text)
  return m ? limitRefusal(m[0]) : null
}

/** "in 3 h 12 m" until `at` (epoch seconds) — the voice allowance's own way of saying it. */
export function resetsIn(at: number, nowMs = Date.now()): string {
  const s = Math.max(0, Math.round(at - nowMs / 1000))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return h > 0 ? `in ${h} h ${m} m` : `in ${Math.max(1, m)} m`
}
